import getUserDevice from 'utils/getUserDevice';
import type { DevicePlatform, Customer } from 'models';
import { ADD_TO_WALLET_URL } from 'constants/default';
import ApplePayButton from 'assets/icons/ApplePayButton';
import { StyledButton, StyledGooglePayButton } from './DevicePayButton.styles';

export interface PayButtonProps {
  user: Customer;
}

type ButtonType = { type: 'Android' | 'iOS' };

const DevicePayButton = ({ type }: ButtonType) => {
  const button: any = {
    Android: <StyledGooglePayButton />,
    iOS: <ApplePayButton />,
  };

  return button[type];
};

const PayButton = ({ user }: PayButtonProps) => {
  const {
    personalDetails: { memberId, customerId },
  } = user;

  const addToWalletUrl = `${ADD_TO_WALLET_URL}/${memberId}/${customerId}`;

  const userDevice: DevicePlatform = getUserDevice();

  if (!userDevice) {
    return null;
  }

  return (
    <StyledButton aria-label={`${userDevice} Pay Button`} LinkComponent="a" href={addToWalletUrl}>
      <DevicePayButton type={userDevice} />
    </StyledButton>
  );
};
export default PayButton;
